/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLibraryRemove = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="M14 15H6v-2h8v2z" fill="currentcolor" />
      <path d="M22 18h-4v4H2V6h4V2h16v16zM4 20h12V8H4v12zM8 6h10v10h2V4H8v2z" fill="currentcolor" />
    </g>
  </Icon>
);
export { SvgLibraryRemove as LibraryRemove };
